var _path, _path2, _circle, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinstagramicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.253397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20859 40.0711C9.20859 40.0711 9.46687 38.6445 10.4825 41.9992C11.4982 45.354 22.9827 52.6964 26.8271 46.75C30.6715 40.8036 36.1066 47.4763 39.861 45.6917C43.6155 43.907 44.2102 41.5517 41.4117 35.8766C38.6132 30.2014 45.4971 23.286 38.6351 18.8401C31.7732 14.3942 37.0854 15.4864 37.0854 15.4864L37.0504 33.6376L27.8651 41.9652L9.20859 40.0711Z",
    fill: "url(#paint0_linear_900_3851)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.518059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4408 22.4032C36.4408 22.4032 35.6429 22.3568 37.4098 21.5654C39.1766 20.7739 42.4197 13.9027 38.9076 12.1734C35.3955 10.4441 38.6797 6.97508 37.4504 5.01303C36.2212 3.05099 34.8926 2.88098 31.9764 4.81928C29.0603 6.75757 23.4344 1.58057 21.4645 5.69011C19.4946 9.79965 22.8407 4.81022 22.8407 4.81022L31.0454 7.39133L36.22 11.9225L36.4408 22.4032Z",
    fill: "url(#paint1_linear_900_3851)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2816,
    cy: 24.3385,
    r: 15.2816,
    stroke: "#FAA9C6",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2472 9.09193C21.9854 8.90617 24.723 9.46123 27.1726 10.6988C29.6222 11.9364 31.6932 13.8108 33.1683 16.1251C34.6433 18.4394 35.4679 21.1083 35.5554 23.8514C35.6429 26.5944 34.99 29.3104 33.6654 31.714C32.3409 34.1176 30.3934 36.1202 28.0277 37.5113C25.6619 38.9025 22.9652 39.6308 20.2208 39.6199C17.4764 39.609 14.7856 38.8592 12.431 37.4493C10.0764 36.0394 8.14493 34.0214 6.8395 31.6074",
    stroke: "url(#paint2_linear_900_3851)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_3851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 32.9609C15.5927 32.9609 11.5625 28.9307 11.5625 23.9609C11.5625 18.9911 15.5927 14.9609 20.5625 14.9609C25.5323 14.9609 29.5625 18.9911 29.5625 23.9609C29.5625 28.9307 25.5323 32.9609 20.5625 32.9609Z",
    fill: "url(#paint3_linear_900_3851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5624 18.9246C22.2022 18.9246 22.3966 18.93 23.0446 18.9606C23.644 18.9876 23.9698 19.0884 24.1858 19.173C24.472 19.2846 24.6772 19.4178 24.8914 19.632C25.1056 19.8462 25.2388 20.0514 25.3504 20.3376C25.435 20.5536 25.534 20.8794 25.5628 21.4788C25.5916 22.1268 25.5988 22.3212 25.5988 23.961C25.5988 25.6008 25.5934 25.7952 25.5628 26.4432C25.5358 27.0426 25.435 27.3684 25.3504 27.5844C25.2388 27.8706 25.1056 28.0758 24.8914 28.29C24.6772 28.5042 24.472 28.6374 24.1858 28.749C23.9698 28.8336 23.644 28.9326 23.0446 28.9614C22.3966 28.9902 22.2022 28.9974 20.5624 28.9974C18.9226 28.9974 18.7282 28.992 18.0802 28.9614C17.4808 28.9344 17.155 28.8336 16.939 28.749C16.6528 28.6374 16.4476 28.5042 16.2334 28.29C16.0192 28.0758 15.886 27.8706 15.7744 27.5844C15.6898 27.3684 15.5908 27.0426 15.562 26.4432C15.5332 25.7952 15.526 25.6008 15.526 23.961C15.526 22.3212 15.5314 22.1268 15.562 21.4788C15.589 20.8794 15.6898 20.5536 15.7744 20.3376C15.886 20.0514 16.0192 19.8462 16.2334 19.632C16.4476 19.4178 16.6528 19.2846 16.939 19.173C17.155 19.0884 17.4808 18.9894 18.0802 18.9606C18.7282 18.93 18.9226 18.9246 20.5624 18.9246ZM20.5624 17.8176C18.8938 17.8176 18.685 17.8248 18.0298 17.8554C17.3764 17.886 16.93 17.9886 16.5376 18.1416C16.1344 18.2964 15.7906 18.507 15.4504 18.849C15.1084 19.191 14.8996 19.533 14.7412 19.938C14.59 20.3286 14.4856 20.775 14.455 21.4302C14.4244 22.0854 14.4172 22.2942 14.4172 23.9628C14.4172 25.6314 14.4244 25.8402 14.455 26.4954C14.4856 27.1488 14.5882 27.5952 14.7412 27.9876C14.8978 28.389 15.1084 28.7328 15.4504 29.073C15.7924 29.415 16.1344 29.6238 16.5394 29.7822C16.93 29.9334 17.3764 30.0378 18.0316 30.0684C18.6868 30.099 18.8956 30.1062 20.5642 30.1062C22.2328 30.1062 22.4416 30.099 23.0968 30.0684C23.7502 30.0378 24.1966 29.9352 24.589 29.7822C24.9904 29.6256 25.3342 29.415 25.6744 29.073C26.0164 28.731 26.2252 28.389 26.3836 27.984C26.5348 27.5934 26.6392 27.147 26.6698 26.4918C26.7004 25.8366 26.7076 25.6278 26.7076 23.9592C26.7076 22.2906 26.7004 22.0818 26.6698 21.4266C26.6392 20.7732 26.5366 20.3268 26.3836 19.9344C26.227 19.533 26.0164 19.1892 25.6744 18.849C25.3324 18.507 24.9904 18.2982 24.5854 18.1398C24.1948 17.9886 23.7484 17.8842 23.0932 17.8536C22.4398 17.8248 22.231 17.8176 20.5624 17.8176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5624 20.8057C18.82 20.8057 17.407 22.2187 17.407 23.9611C17.407 25.7035 18.82 27.1165 20.5624 27.1165C22.3048 27.1165 23.7178 25.7035 23.7178 23.9611C23.7178 22.2187 22.3048 20.8057 20.5624 20.8057ZM20.5624 26.0095C19.432 26.0095 18.514 25.0933 18.514 23.9611C18.514 22.8289 19.432 21.9127 20.5624 21.9127C21.6928 21.9127 22.6108 22.8289 22.6108 23.9611C22.6108 25.0933 21.6928 26.0095 20.5624 26.0095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.842 21.4194C24.2496 21.4194 24.58 21.0889 24.58 20.6814C24.58 20.2738 24.2496 19.9434 23.842 19.9434C23.4344 19.9434 23.104 20.2738 23.104 20.6814C23.104 21.0889 23.4344 21.4194 23.842 21.4194Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_900_3851",
    x1: 10.5934,
    y1: 22.8522,
    x2: 64.4061,
    y2: 42.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_900_3851",
    x1: 26.5736,
    y1: 22.709,
    x2: 34.0769,
    y2: -8.44413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_900_3851",
    x1: 22.3097,
    y1: -2.32805,
    x2: 24.5982,
    y2: 69.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_900_3851",
    x1: 14.1985,
    y1: 30.3249,
    x2: 26.9265,
    y2: 17.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0551048,
    stopColor: "#FFD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    stopColor: "#FEC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    stopColor: "#FCA71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#FA8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "#F85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#F51E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#F20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#E1003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    stopColor: "#D30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    stopColor: "#C70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    stopColor: "#BF00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    stopColor: "#BB00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_3851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11.5625 14.9609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinstagramicon);
export default __webpack_public_path__ + "static/media/minstagramicon.604140be5cef18f54a598a9f9d66b56b.svg";
export { ForwardRef as ReactComponent };